import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import NfcProjects from './NfcProjects';
import NfcTaskItem from './NfcTaskItem';
import { TaskNavigate } from './TaskNavigate';
import TaskAction from '../../models/TaskAction';
var styles = {
    header: {
        textOverflow: 'ellipsis',
    },
    title: {
        textOverflow: 'ellipsis',
    },
    item: {
        margin: '1rem auto',
        padding: '0',
        color: '#414141',
        cursor: 'pointer',
        width: '25%'
    },
    text: {
        fontSize: '12px',
        paddingRight: 0,
        maxWidth: '300px',
    },
};
var NfcTaskPage = /** @class */ (function (_super) {
    tslib_1.__extends(NfcTaskPage, _super);
    function NfcTaskPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onPreferencesChanged = function () {
            _this.props.nfcTaskStore.filter.viewOption = _this.props.preferencesStore.cardViewFilter.value;
            _this.props.nfcTaskStore.taskFilter.viewOption = _this.props.preferencesStore.cardViewFilter.value;
        };
        _this.load = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.nfcTaskStore.loadNfcTasks(this.props.userStore.userIdForLoading)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleProjectSelect = function (projectId) {
            _this.props.nfcTaskStore.setSelectedTask(projectId);
        };
        _this.handleTaskItemSelect = function (item) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item.statusId = 4;
                        return [4 /*yield*/, this.props.nfcTaskStore.updateTask(item)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleItemfinished = function (item) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ selectedTask: null });
                        return [4 /*yield*/, this.props.nfcTaskStore.finishTask(item)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleBack = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var runningTask;
            return tslib_1.__generator(this, function (_a) {
                runningTask = this.props.nfcTaskStore.getRunningTask();
                if (runningTask) {
                    runningTask.statusId = 2;
                    this.props.nfcTaskStore.updateTask(runningTask);
                }
                this.setState({ selectedTask: null });
                return [2 /*return*/];
            });
        }); };
        _this.handleItemPause = function (item) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tmp, taskAction;
            return tslib_1.__generator(this, function (_a) {
                tmp = {
                    taskID: item.id,
                    partobjectID: item.partObjectID,
                    head: item.headId,
                    userID: item.userId,
                    isPause: true
                };
                taskAction = new TaskAction(tmp);
                this.props.nfcTaskStore.taskAction(taskAction);
                return [2 /*return*/];
            });
        }); };
        _this.handleItemStart = function (item) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tmp, taskAction;
            return tslib_1.__generator(this, function (_a) {
                tmp = {
                    taskID: item.id,
                    partobjectID: item.partObjectID,
                    head: item.headId,
                    userID: item.userId,
                    isPause: false
                };
                taskAction = new TaskAction(tmp);
                this.props.nfcTaskStore.taskAction(taskAction);
                return [2 /*return*/];
            });
        }); };
        _this.props.nfcTaskStore.initialize();
        _this.load();
        return _this;
    }
    NfcTaskPage.prototype.componentWillMount = function () {
        this.props.nfcTaskStore.filter.viewOption = this.props.preferencesStore.cardViewFilter.value;
    };
    NfcTaskPage.prototype.componentDidMount = function () {
        this.props.preferencesStore.changed.subscribe(this.onPreferencesChanged);
    };
    NfcTaskPage.prototype.componentWillUnmount = function () {
        this.props.preferencesStore.changed.unsubscribe(this.onPreferencesChanged);
    };
    NfcTaskPage.prototype.render = function () {
        var _this = this;
        var nfcTaskStore = this.props.nfcTaskStore;
        if (!nfcTaskStore.nfcTasks) {
            return null;
        }
        var runningTask = nfcTaskStore.getRunningTask();
        var runningTaskUi = runningTask ? (React.createElement(NfcTaskItem, { key: runningTask.id + runningTask.workerStatus, nfcTaskItem: runningTask, isRunning: true, color: nfcTaskStore.getStatusByID(runningTask.statusId).color, onItemFinished: this.handleItemfinished, onItemPause: this.handleItemPause, onItemStart: this.handleItemStart })) : null;
        var projects = (runningTaskUi || nfcTaskStore.getSelectedTask()) ? null : nfcTaskStore.getNfcTask().map(function (item) {
            return React.createElement(NfcProjects, { key: item.projectId, nfcTask: item, onItemClick: _this.handleProjectSelect });
        });
        var tasks = !runningTaskUi && nfcTaskStore.getSelectedTask() ? (nfcTaskStore.getSelectedTask().tasks.map(function (item) { return React.createElement(NfcTaskItem, { key: item.id, nfcTaskItem: item, onItemClicked: _this.handleTaskItemSelect, isRunning: false }); })) : null;
        return (React.createElement(React.Fragment, null,
            React.createElement(TaskNavigate, null),
            runningTaskUi,
            projects,
            tasks));
    };
    NfcTaskPage = tslib_1.__decorate([
        inject('userStore', 'nfcTaskStore', 'preferencesStore'),
        observer
    ], NfcTaskPage);
    return NfcTaskPage;
}(React.Component));
export default NfcTaskPage;



//////////////////
// WEBPACK FOOTER
// ./src/pages/nfctask/NfcTaskPage.tsx
// module id = 805
// module chunks = 0